import { render, staticRenderFns } from "./admin-statistic-user-status-counts.vue?vue&type=template&id=0f7d2432&scoped=true"
import script from "./admin-statistic-user-status-counts.vue?vue&type=script&lang=js"
export * from "./admin-statistic-user-status-counts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7d2432",
  null
  
)

export default component.exports